import Vue from "vue";
import axios from 'axios'
import {
  Message
} from 'element-ui'
window.$Vue = new Vue() //替代this
// 导出excel
export function DownloadBlob(config) {
  const {
    url,
    data
  } = Object.assign({
    url: '',
    data: {}
  }, config)
  return new Promise((resolve, reject) => {

    window.$Vue.$axios.dowBlodGet(url, data, false).then((res) => {

      const resData = res.data
      const fileReader = new FileReader()
      fileReader.onloadend = () => {

        if (resData.type === 'application/json') {
          const jsonData = JSON.parse(fileReader.result) // 说明是普通对象数据，后台转换失败 ] 
          if (jsonData.code != 0) {
            Message({
              showClose: true,
              message: jsonData.msg,
              type: "error",
              offset: 80
            })
          }
        } else {
          // 下载文件 
          console.log(res);
          const disposition = res.headers['content-disposition']
          const fileName = decodeURI(disposition.split('filename*=UTF-8\'\'')[1] || disposition.split('filename*=UTF-8\'\'')[1])
          console.log(fileName)
          const url = window.URL.createObjectURL(new Blob([res.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          resolve()
        }
      }
      fileReader.readAsText(resData)
    }).catch((err) => {
      let msg = '文件下载失败！'
      const resData = err.response.data
      const fileReader = new FileReader()
      fileReader.onload = () => {
        if (resData.type === 'application/json') {
          const jsonData = JSON.parse(fileReader.result) // 说明是普通对象数据，后台转换失败 ]  
          if (jsonData.code != 0) {
            msg = jsonData.msg
          }
        }
        Message({
          showClose: true,
          message: msg,
          type: "error",
          offset: 80
        })
        reject(new Error(msg))
      }
      fileReader.readAsText(resData)
      //  Message({
      //   showClose: true,
      //   message: msg,
      //   type: "error",
      //   offset: 80
      // })
      // reject(new Error(msg))
    })
  })
}
// 导出excel
export function DownloadBlobPost(config) {
  const {
    url,
    data
  } = Object.assign({
    url: '',
    data: {}
  }, config)
  return new Promise((resolve, reject) => {
    window.$Vue.$axios.dowBlodPost(url, data, false).then((res) => {
      const disposition = res.headers['content-disposition']
      const fileName = decodeURI(disposition.split('filename*=UTF-8\'\'')[1] || disposition.split('filename*=UTF-8\'\'')[1])
      console.log(fileName)
      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      resolve()
    }).catch((err) => {
      reject(new Error('文件下载失败！'))
    })
  })
}
// 查看图片
export function DownloadImg(config) {
  const {
    url,
    data
  } = Object.assign({
    url: '',
    data: {}
  }, config)
  return new Promise((resolve, reject) => {
    window.$Vue.$axios.dowImgGet(url, data, false).then((res) => {
      resolve('data:image/png;base64,' + btoa(new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), '')))
    }).catch((err) => {
      reject(new Error('图片下载失败！'))
    })
  })
}